import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { CapabilitiesListComponent } from './capabilities-list/capabilities-list.component';
import { CapabilitiesDetailComponent } from './capabilities-detail/capabilities-detail.component';
import { CapabilitiesRoutingModule } from './capabilities-routing.module';
import { InputSwitchModule } from 'primeng/inputswitch';


@NgModule({
    declarations: [
        CapabilitiesListComponent,
        CapabilitiesDetailComponent
    ],
    imports: [
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        HttpClientModule,
        FormsModule,
        TableModule,
        CardModule,
        CapabilitiesRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        ConfirmDialogModule,
        InputSwitchModule
    ]
})
export class CapabilitiesModule { }
